import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import PhoneNumber from "libphonenumber-js";

export default function PhoneInputWithCountryCode({ setPhone, label = "Phone *" }) {
  const [isValid, setIsValid] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [formattedPhone, setFormattedPhone] = useState("");
  const [isFocused, setIsFocused] = useState(false);


  useEffect(() => {
    if (isValid) {
      setPhone(formattedPhone);
    } else {
      setPhone("");
    }
  }, [isValid, setPhone, formattedPhone]);

  const handlePhoneChange = (phone, country, e, formattedValue) => {
    try {
      const parsedNumber = PhoneNumber(formattedValue);
      setIsValid(parsedNumber.isValid());
      setFormattedPhone(formattedValue);
    } catch (error) {
      console.error(error);
    }
  };

  const handleClick = () => {
    setIsClicked(true);
  };
  const handleInputFocus = () => {
    setIsFocused(true);
  };

  return (
    <div>
      <PhoneInput
        specialLabel= {<span
          style={{
            color:  isFocused ? "#1D9DF0" : "black"
          }}
        >
          {label}
        </span>}
        inputStyle={{
          color: "black",
          display: "block",
          height: "46px",
          width: "100%",
          marginTop: "10px",
         }}
        inputProps={{
          
          name: "phone",
          required: true,
          // autoFocus: true,
        }}
        country={"nl"}
        onChange={handlePhoneChange}
        onClick={handleClick}
        onFocus={handleInputFocus}
        onBlur= {()=>setIsFocused(false)}
       />
      {!isValid && isClicked && isFocused && (
        <span
          style={{
            color: "#ff1744",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 400,
            fontSize: "0.75rem",
          }}
        >
          Invalid phone number
        </span>
      )}
    </div>
  );
}
